import { render, staticRenderFns } from "./SetOptionItem.vue?vue&type=template&id=4d3db34f&scoped=true"
import script from "./SetOptionItem.vue?vue&type=script&lang=js"
export * from "./SetOptionItem.vue?vue&type=script&lang=js"
import style0 from "./SetOptionItem.vue?vue&type=style&index=0&id=4d3db34f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3db34f",
  null
  
)

export default component.exports